"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
function Nav(attrs) {
    var data = attrs.data, isMobile = attrs.isMobile, closeDrawer = attrs.closeDrawer, logo = attrs.logo, onLinkClick = attrs.onLinkClick;
    return (0, mithril_1.default)('.Docs-nav', { class: isMobile ? 'is-mobile' : '' }, (0, mithril_1.default)('.Docs-nav-content', [
        (0, mithril_1.default)('.Docs-nav-header', [
            logo,
            (0, mithril_1.default)('', [
                (0, mithril_1.default)('.Docs-nav-title', 'Construct-ui'),
                (0, mithril_1.default)('.Docs-nav-title-meta', [
                    (0, mithril_1.default)('a', {
                        href: 'https://github.com/vrimar/construct-ui',
                        target: '_blank'
                    }, 'Github'),
                    (0, mithril_1.default)('.Docs-nav-version', "(v".concat(VERSION, ")"))
                ])
            ])
        ]),
        data.docs.nav.map(function (heading) { return (0, mithril_1.default)('.Docs-nav-section', [
            (0, mithril_1.default)('h4', heading.title),
            heading.children.map(function (child) { return [
                (0, mithril_1.default)('a', {
                    class: "/".concat(child.route) === mithril_1.default.route.get() ? 'is-active' : '',
                    onclick: function (e) {
                        onLinkClick(e);
                        closeDrawer();
                        mithril_1.default.route.set("#/".concat(child.route));
                    },
                    href: "#/".concat(child.route)
                }, child.title)
            ]; })
        ]); })
    ]));
}
exports.Nav = Nav;
